import { state } from "./state";
import { defineStoreActions } from "~/stores";
import { id } from "./id";
import { getters } from "./getters";
import { repository } from "~/repository";
import { isSystemOnlyMessage, transformMessage } from "~/utils/chat";

export const actions = defineStoreActions(
  {
    id,
    state,
    getters,
  },
  {
    async initChat(videoId: string) {
      const { data: chatHistory } = await repository.chat.fetchChatHistory({
        videoId: videoId,
      });

      const stickers = await repository.chat.fetchStickers();

      this.$patch((state) => {
        state.messages = (chatHistory || [])
          .filter((el) => !isSystemOnlyMessage(el))
          .map((message) => transformMessage(message));

        state.stickers = stickers;
      });
    },
    async getStatusData(videoId: string) {
      const { setting: statusDataSettings } =
        await repository.chat.getStatusData({
          videoId: videoId,
        });
      this.$patch((state) => {
        state.chatEnabled = statusDataSettings.chat_enabled;
        state.chatStatus = statusDataSettings.chat_status;
      });
    },
  },
);
